import React, { FC, memo } from 'react';
import styled from '@emotion/styled';
import { useStorage } from '~Components/Storage';
import Order from '~Scenes/EventedKitchenDisplay/Components/Order';
import {
  ORDER_ORIGIN,
  ORDER_STATUS,
  Order as OrderType,
  SERVICE_TYPE,
} from '@baemingo/order-status-events/dist/types';
import { DateTime } from 'luxon';
import { GetOrder_order } from '~Queries/__queries__';

const MOCK_ITEMS = [
  {
    categoryId: 'undefined',
    comment: '',
    id: 'd87e58f8-82a2-4764-a70a-566baabe0734',
    itemId: 'mock-id',
    orderId: '1a27cb61-9c7d-44b9-b790-be0393ffe0a1',
    parentId: null,
    removedVariations: [],
    status: ORDER_STATUS.ACCEPTED,
    variations: [],
    courseId: null,
  },
];

/* Mock of an App order that is due ASAP - This to be able to showcase the ETA bar setting storage.showOrderEtaBar */
const ORDER_MOCK: OrderType = {
  createdAt: DateTime.now().toISO(),
  id: '1a27cb61-9c7d-44b9-b790-be0393ffe0a1',
  realId: 'ckzqrqct8cg2908179stfmr4g',
  status: ORDER_STATUS.ACCEPTED,
  comment: '',
  tableName: '123',
  serviceType: SERVICE_TYPE.TAKE_AWAY,
  easyId: null,
  fired: true,
  tableId: null,
  origin: ORDER_ORIGIN.APP,
  estimatedFinishTime: null,
};

const OrderContainer = styled.div<{
  showFiveColumns: boolean;
}>`
  text-overflow: ellipsis;
  width: ${({ showFiveColumns }) => (showFiveColumns ? '365px' : '460px')};
  margin: 0 auto;
  margin-top: 30px;
  pointer-events: none;
  font-weight: 600;
`;

const OrderMock: FC = () => {
  const [storage] = useStorage();

  const REAL_ORDER_MOCK: GetOrder_order = {
    __typename: 'Order',
    id: '1a27cb61-9c7d-44b9-b790-be0393ffe0a1',
    origin: ORDER_ORIGIN.APP,
    estimatedFinishTime: DateTime.now()
      .plus({ minutes: 20 })
      .toISO(),
    desiredTime: null,
    user: {
      __typename: 'User',
      id: '1',
      name: 'John Doe',
    },
    payment: {
      __typename: 'Payment',
      type: 'CARD',
      id: 'payment-id',
    },
  };

  return (
    <div>
      <OrderContainer showFiveColumns={storage.showFiveColumns}>
        <Order
          order={ORDER_MOCK}
          realOrder={REAL_ORDER_MOCK}
          venueId={'venueId'}
          items={MOCK_ITEMS}
        />
      </OrderContainer>
    </div>
  );
};

export default memo(OrderMock);
